export default __webpack_public_path__ + "static/media/24.79a743c2.jpeg";